import type { Theme } from '@mui/material/styles';

/**
 * ログイン系ボタンの共通グラス面スタイル。
 * PULSEの半透明パネル調に合わせ、面は中立トーンで統一し、
 * ブランドの差別化はロゴのカラーだけで行う（A案）。
 * ライト/ダーク両テーマ対応。Steam/Xbox ボタンとも高さが揃うよう
 * variant="outlined" + py:0.75 + 1px border を前提にしている。
 */
export const glassButtonSx = (theme: Theme) => {
  const dark = theme.palette.mode === 'dark';
  return {
    color: 'text.primary',
    backgroundColor: dark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.025)',
    border: `1px solid ${dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
    boxShadow: 'none',
    backdropFilter: 'blur(8px)',
    textTransform: 'none',
    fontWeight: 500,
    py: 0.75,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)',
      borderColor: dark ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.22)',
      boxShadow: 'none',
    },
  };
};
